import { PropsWithChildren } from 'react'
import { useTranslation } from 'libs/i18n'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type FiltersPanelProps = PropsWithChildren<
	WithClassName<{
		title: string
		onClear: () => void
	}>
>

export const FiltersPanel = ({ title, className, children, onClear }: FiltersPanelProps) => {
	const { t } = useTranslation()

	return (
		<div className="mt-4 rounded-lg border border-border bg-muted/40 p-4">
			<div className="mb-3 flex items-center justify-between gap-3">
				<span className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
					{title}
				</span>
				<button
					type="button"
					className="text-[12px] font-medium text-muted-foreground transition-colors hover:text-foreground"
					onClick={onClear}>
					{t('Clear all')}
				</button>
			</div>
			<div className={cn('grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-5', className)}>
				{children}
			</div>
		</div>
	)
}

type FilterFieldProps = PropsWithChildren<
	WithClassName<{
		label: string
	}>
>

export const FilterField = ({ label, className, children }: FilterFieldProps) => (
	<div className={cn('min-w-0', className)}>
		<span className="mb-1 block text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
			{label}
		</span>
		{children}
	</div>
)
